module.exports = __webpack_public_path__ + "b725c3d61bac64d55bb472a90071adcf.png";